import { Component } from '@angular/core';
import { MagentoService } from 'src/app/services/magento.service';

@Component({
  selector: 'ng-hbm-bdi-error',
  templateUrl: './error.component.html'
})
export class ErrorComponent {


  constructor(public magento: MagentoService) { 
    clearInterval(this.magento.timeoutID);
  }
}
